<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import pageDataMixin from '@qx/mixin/pageData';
import {createInventoryInAndOutDetails} from 'api/service';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/service/inventoryManagement/inventoryDetail/edit',
      formComponents: ['baseForm'],
      subLoading: false,
    };
  },
  watch: {
    '$route.path': function (val) {
      if (val === this.pageUrl) {
        this.getEnum();
      }
    },

  },
  methods: {
    editApi: createInventoryInAndOutDetails,
    async getEnum () {
      await this.$nextTick(() => {
        this.$refs.baseForm.getList();
      });
    },
  },
  async mounted () {
    this.getData();
    this.getEnum();
  },
};
</script>

<style scoped lang="scss">
</style>
